<template>
  <b-modal
    size="lg"
    id="modalEditParameter"
    ref="modalEditParameter"
    centered
    title="Parametro"
    header-bg-variant="warning"
    hide-footer
  >
    <form class="needs-validation" ref="form" novalidate @submit.prevent="(e) => save(e)">
      <b-row>
        <b-col>
          <div class="form-group">
            <label class="form-label">Nome:</label>
            <input class="form-control" v-model.trim="parameter.name" required type="text" />
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label class="form-label">Codice:</label>
            <input class="form-control" v-model.trim="parameter.code" required type="text" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="form-group">
            <label class="form-label">Grandezza:</label>
            <input class="form-control" v-model.trim="parameter.parameter" required type="text" />
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label class="form-label">Codice esterno:</label>
            <input class="form-control" v-model.trim="parameter.esv_field" type="text" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="form-group">
            <label class="form-label">Unità di misura:</label>
            <input class="form-control" v-model.trim="parameter.mu" required type="text" />
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label class="form-label">Valore:</label>
            <input class="form-control" v-model.trim="parameter.value" type="number" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="form-group">
            <label class="form-label">Funzione di aggregazione:</label>
            <b-select v-model="parameter.grouping" required>
              <option value="sum">Somma</option>
              <option value="avg">Media aritmetica</option>
            </b-select>
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label class="form-label">Granularità minima:</label>
            <b-select v-model="parameter.min_sampling" required>
              <option v-for="(item, index) in samplingList" :key="index" :value="item.value">{{ item.text }}</option>
            </b-select>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="form-group">
            <label class="form-label">Genitore:</label>
            <v-select
              :clearable="false"
              v-model="parameter.parent_code"
              :options="parentCodeList"
              :reduce="(item) => item.value"
              label="text"
              value="value"
              :selectable="(e) => e.value != parameter.code"
            />
          </div>
        </b-col>
        <b-col>
          <div class="form-group" v-if="isParent">
            <label class="form-label">Formula:</label>
            <v-select
              :clearable="false"
              v-model="parameter.formula"
              :options="[
                { label: '--', value: null },
                { label: 'Somma', value: 'children-sum' },
              ]"
              :reduce="(item) => item.value"
              label="label"
              value="value"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex justify-content-end">
          <b-btn class="mr-2" variant="secondary" @click="$bvModal.hide('modalEditParameter')">Annulla</b-btn>
          <b-btn v-if="!isNew" class="mr-2" variant="danger" @click="removeParameter()">Rimuovi parametro</b-btn>
          <b-btn v-if="!isNew" type="submit" variant="primary">Modifica</b-btn>
          <b-btn v-else type="submit" variant="primary">Aggiungi</b-btn>
        </b-col>
      </b-row>
    </form>
  </b-modal>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { getSamplings } from "../../../../helpers/measure";

export default {
  name: "ParameterModal",
  props: ["parameters", "parameter", "siteGuid"],
  components: { vSelect },
  data() {
    return {};
  },
  created() {
    console.log(getSamplings());
  },
  methods: {
    async save() {
      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.classList.add("was-validated");
        return;
      }

      this.parameter.siteGuid = this.siteGuid;
      var storeData = {
        site_guid: this.siteGuid,
        parameter: {
          ...this.parameter,
        },
      };
      const action = this.isNew ? "add" : "edit";
      if (this.isNew) {
        if (this.parametersList.some((item) => item.code == this.parameter.code)) {
          this.$notify({
            type: "error",
            text: "Codice parametro già esistente",
            title: "Errore",
          });
          return;
        }
      }

      this.$store.commit("loading");
      await this.$store.dispatch(`sites/${action}Parameter`, storeData);
      this.$store.commit("stopLoading");

      this.$notify({
        type: "success",
        text: "Parametro salvato correttamente",
      });

      this.$bvModal.hide("modalEditParameter");
      this.$emit("saved");
    },
    async removeParameter() {
      this.$store.commit("loading");
      await this.$store.dispatch(`sites/deleteParameter`, this.parameter.id);
      this.$store.commit("stopLoading");

      this.$bvModal.hide("modalEditParameter");
      this.$emit("saved");
    },
  },
  computed: {
    parametersList() {
      return Array.isArray(this.parameters) ? this.parameters : [];
    },
    samplingList() {
      return getSamplings();
    },
    isNew() {
      return !this.parameter.id;
    },
    isParent() {
      return this.parametersList.some((p) => p.parent_code == this.parameter.code);
    },
    parentCodeList() {
      let result = [];

      this.parametersList.forEach((item) => {
        result.push({ text: item.name, value: item.code });
      });

      result.unshift({ text: "--", value: null });

      return result;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Admin/Sites/Parameters/ParameterModal.vue